import { isEarlyCacheReturnEnabled } from '../earlyCacheReturn';
import { Metrics } from '../metrics';
import { conditionalPropertyRulesPersistedPromise } from 'fdsr-migration-layer';
export const makeConditionalPropertyRulesClient = ({
  rpcClient,
  persistedPromise = conditionalPropertyRulesPersistedPromise
}) => Promise.resolve({
  debug: () => {
    persistedPromise.debug();
  },
  clearCache: () => {
    persistedPromise.clearCache();
    return Promise.resolve();
  },
  get: ({
    frameworkTypeIdentifier,
    query,
    refetch = false
  }) => {
    Metrics.counter('conditionalPropertyRules.get').increment();
    return persistedPromise.makeFetchWithOpts({
      allowEagerCacheReturn: isEarlyCacheReturnEnabled(),
      refresh: refetch
    })({
      rpcClient,
      frameworkTypeIdentifier,
      query
    });
  }
});